<template>
  <div>
    <div class="d-flex justify-content-center m-t-32">
      <div class="col-md-12 col-lg-8 position-relative">
        <div class="css_pageTitle2 m-b-16">Редактор Рубрики:</div>
        <select
            v-model="editableArticle.rubric_id"
            class="form-select form-select-sm  mb-3"
        >
          <option
              v-for="rubric in rubrics"
              :key="rubric.id"
              :value="rubric.id"
          >{{rubric.name}}</option>
        </select>
        <select
            @change="changeArticleByLanguage"
            v-model="editableArticle.current_edit_lang"
            class="form-select form-select-sm  mb-3"
        >
          <option value="ru" selected>Русский</option>
          <option value="en">Английский</option>
        </select>
        <div class="mb-3">
          <label class="form-label">Ссылка</label>
          <div class="row">
            <label class="col-sm-4 col-form-label col-form-label-sm">https://help.puzzlebot.top/</label>
            <div class="col-sm-8">
              <input
                  v-model="editableArticle.link"
                  type="text" class="form-control form-control-sm"
              >
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label">Заголовок</label>
          <input
              v-model="editableArticle.content_lang[editableArticle.current_edit_lang].title.value"
              @blur="editableArticle.content_lang[editableArticle.current_edit_lang].title.blur"
              :class="{'is-invalid': !editableArticle.content_lang[editableArticle.current_edit_lang].title.valid && editableArticle.content_lang[editableArticle.current_edit_lang].title.touched}"
              type="text" class="form-control form-control-sm"
          >
        </div>
        <div class="mb-3">
          <label class="form-label">Мета текст</label>
          <input
              v-model="editableArticle.content_lang[editableArticle.current_edit_lang].meta_text"
              type="text" class="form-control form-control-sm"
          >
        </div>
        <select
            v-model="editableArticle.content_lang[editableArticle.current_edit_lang].status"
            class="form-select form-select-sm mb-3"
        >
          <option value="0" selected>Черновик</option>
          <option value="1">Публикация</option>
        </select>

        <div class="content_zone">
          <label class="form-label">Текст:</label>
          <div class="redactor box_2">
            <ckeditor
                :editor="articleEditor"
                v-model="editableArticle.content_lang[editableArticle.current_edit_lang].content.value"
            ></ckeditor>
          </div>
        </div>
      </div>
    </div>
    <div class="box_attach_file" style="display: none;">
      <input
          ref="uploadfile"
          @change="handleFileUpload"
          type="file" name="files[]" accept="*"
      >
    </div>
    <button
        @click="copyArticleImage"
        type="button" class="btn btn-primary copy_image" title="Скопировать"
    ><img src="https://cp.puzzlebot.top/icons/copy2.svg" class="icon_copy m-t-0" width="20"></button>
    <button
        @click="prepareUploadArticleImage"
        type="button" class="btn btn-primary upload_image" title="Загрузить"
    ><img src="https://cp.puzzlebot.top/icons/upload_white.svg" class="icon_copy m-t-0" width="20"></button>
    <button
        @click="saveEditArticle"
        type="button" class="btn btn-primary save_help_article"
    ><img src="https://cp.puzzlebot.top/icons/save_white.svg" width="20"></button>
  </div>
</template>

<script>
import { ref, computed, reactive, watch } from "vue";
import {storeToRefs} from "pinia";
import {useField, validatorsList} from "../helpers/validateField";
import {DEFAULT_LANGUAGE_CODE} from "../../../shared/constants/consts";

import ClassicEditor from '../plugins/сkeditor'
import {useClientStorage, useRubricArticleStore} from "../../../stores/store";
import {AddOrUpdateArticleById, cleanContentLangFromValidateField, prepareSaveArticleAJ} from "../services/util";
import {uploadImage} from "@/api/http";

export default {
  props: {
    usedArticle: { type: Object, required: true }
  },
  emits: ['save-edit-article'],
  setup(props, { emit }) {

    const rubricArticleStore = useRubricArticleStore();
    const { rubrics, articles } = storeToRefs(rubricArticleStore);

    const clientStorage = useClientStorage();
    const lang = clientStorage.clientObj.lang;

    const {required} = validatorsList();

    const contentLangHandled = (content_lang, lang) => {
      let new_content_lang = {};

      if(content_lang === null) {
        new_content_lang = initContentLangByLang(lang);
      }
      else {
        for (let cur_lang in content_lang) {
          const currentContentLangObj = content_lang[cur_lang];

          const contentLangByLang = initContentLangByLang(
              cur_lang,
              currentContentLangObj.title,
              currentContentLangObj.content,
              currentContentLangObj.meta_text,
              currentContentLangObj.status
          )

          new_content_lang = Object.assign(new_content_lang, contentLangByLang);
        }
      }

      return new_content_lang;
    }

    const initContentLangByLang = (lang, title = '', content = '', meta_text = '', status = 0) => {
      let obj = {};

      obj[lang] = {
        title: useField({
          value: title,
          validators: {required}
        }),
        meta_text: meta_text,
        lang: lang,
        content: useField({
          value: content,
          validators: {required}
        }),
        status: status
      };

      return obj;
    }

    const editableArticle = reactive({
      id: props.usedArticle.id,
      date: props.usedArticle.date,
      rubric_id: props.usedArticle.rubric_id,
      content_lang: contentLangHandled(props.usedArticle.content_lang, props.usedArticle.current_edit_lang),
      link: props.usedArticle.link,
      current_edit_lang: props.usedArticle.current_edit_lang,
      valid: computed(() => {
        let valid = true;
        for (let lang in editableArticle.content_lang) {
          if(!editableArticle.content_lang[lang].title.valid) {
            valid = false;
          }

          if(!editableArticle.content_lang[lang].content.valid) {
            valid = false;
          }
        }

        return valid;
      })
    });

    watch(
        () => props.usedArticle,
        (oldValue, newValue) => {
          const current_edit_lang = newValue.current_edit_lang;

          editableArticle.id = newValue.id;
          editableArticle.rubric_id = newValue.rubric_id;
          editableArticle.content_lang = contentLangHandled(newValue.content_lang, current_edit_lang);
          editableArticle.link = newValue.link;
          editableArticle.date = newValue.date;
          editableArticle.current_edit_lang = current_edit_lang;
        },
        {
          deep: true
        }
    )

    const changeArticleByLanguage = (event) => {
      let lang = DEFAULT_LANGUAGE_CODE;

      if(event.target.value === 'en') {
        lang = event.target.value;
      }

      if(!Object.prototype.hasOwnProperty.call(editableArticle.content_lang, lang)) {
        Object.assign(editableArticle.content_lang, initContentLangByLang(lang));
      }

      editableArticle.current_edit_lang = lang;
    }

    const saveEditArticle = () => {
      if(!editableArticle.valid) {

        for (let lang in editableArticle.content_lang) {
          if(!editableArticle.content_lang[lang].title.valid) {
            editableArticle.content_lang[lang].title.touched = true;
          }

          if(!editableArticle.content_lang[lang].content.valid) {
            editableArticle.content_lang[lang].content.touched = true;
          }
        }

        return;
      }

      const {id, date, rubric_id, content_lang, link} = editableArticle;

      const newArticleObj = {
        id,
        date,
        rubric_id,
        content_lang: cleanContentLangFromValidateField(content_lang),
        link
      };

      prepareSaveArticleAJ(newArticleObj).then((r) => {
        const newId = r.id;
        const newDate = r.date;
        AddOrUpdateArticleById(articles, newArticleObj, newArticleObj.rubric_id, newArticleObj.id, newId, newDate);

        emit("save-edit-article")
      });
    }

    const copyArticleImage = () => {
      if(filePath.value == '')
      {
        alert('Буфер пустой');
      }
      else
      {
        var img=document.createElement('img');
        img.src=filePath.value;
        document.body.appendChild(img);
        window.getSelection().removeAllRanges();
        var r = document.createRange();
        r.setStartBefore(img);
        r.setEndAfter(img);
        r.selectNode(img);
        var sel = window.getSelection();
        sel.addRange(r);

        document.execCommand('copy');

        window.getSelection().removeAllRanges();

        document.body.removeChild(img);

        alert('Изображение скопировано');
      }
    }

    const uploadfile = ref(null)

    const filePath = ref('')

    const prepareUploadArticleImage = () => {
      uploadfile.value.click()
    }

    const handleFileUpload = async() => {
      const file = uploadfile.value.files[0];

      uploadImage(props.usedArticle.id, lang, file).then(r => {
        if(r.ok)
        {
          alert('Файл загружен');
          filePath.value = `https://cp.puzzle.bot/f/${r.hashs_files['file_path']}`;
          return r;
        }
        else
        {
          throw new Error(r.error);
        }
      }).catch((error) => {
        alert(error)
        return false;
      });
    }

    return {
      rubrics,
      editableArticle,
      changeArticleByLanguage,
      saveEditArticle,
      copyArticleImage,
      prepareUploadArticleImage,
      uploadfile,
      handleFileUpload,
      articleEditor: ClassicEditor
    }
  }
}
</script>

<style scoped>
.save_help_article, .upload_image, .copy_image{
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 52px;
  height: 52px;
}

.upload_image{
  left: 20px !important;
}

.copy_image{
  left: 86px !important;
}
</style>